import { render, staticRenderFns } from "./allSilderH5.vue?vue&type=template&id=6cdf005a&scoped=true&"
import script from "./allSilderH5.vue?vue&type=script&lang=js&"
export * from "./allSilderH5.vue?vue&type=script&lang=js&"
import style0 from "./allSilderH5.vue?vue&type=style&index=0&id=6cdf005a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdf005a",
  null
  
)

export default component.exports